module.exports = __webpack_public_path__ + "assets/flag.99d31253.svg";